import React from 'react';
import styled from 'styled-components/macro';
import { TABLET_LANDSCAPE } from '@tovia/man-ui';
import PanelsTab from '../Tabs/PanelsTab';
import { Panel } from '../Panels/Panel';
import { Panels } from '../Panels/Panels';
import { PaginationPlaceholder } from 'src/client/components/Placeholders/Cards/PaginationPlaceholder';
import { GalleryCardPlaceholder } from '../Cards/GalleryCardPlaceholder';
import { GalleryNavigationPlaceholder } from '../Cards/GalleryNavigationPlaceholder';

type Props = {
  count: number;
  className?: string;
};

export const GalleryPlaceholder = (props: Props) => {
  const { count = 40 } = props;

  return (
    <div className={`placeholder-wrap ${props.className}`} role="progressbar">
      <PanelsTab />
      <StyledPanels />
      <DescriptionPanel width={100} height={157} />
      {/*Navigation*/}
      <Header>
        <GalleryNavigationPlaceholder direction="left" />
        <PaginationPlaceholder />
        <GalleryNavigationPlaceholder direction="right" />
      </Header>
      {/*Cards*/}
      <GalleryCardsWrap>
        {[...Array(count)].map((elem, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <GalleryCardPlaceholder key={i} />
        ))}
      </GalleryCardsWrap>
      {/*Navigation*/}
      <Header>
        <GalleryNavigationPlaceholder direction="left" />
        <PaginationPlaceholder />
        <GalleryNavigationPlaceholder direction="right" />
      </Header>
      {/*Live cams*/}
      <DescriptionPanel width={100} height={246} />
      {/*Comments*/}
      <DescriptionPanel width={100} height={293} />
      {/*Network gallery slider*/}
      <DescriptionPanel width={100} height={431} />
    </div>
  );
};

const StyledPanels = styled(Panels)`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 20px;

  /* Because a placeholder below has a margin-top of 4 */
  margin-bottom: 16px;

  & > div {
    grid-column: span 4;
  }

  .line {
    height: 196px;
  }
`;

const DescriptionPanel = styled(Panel)`
  .line {
    height: 77px;

    @media ${TABLET_LANDSCAPE} {
      height: 157px;
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const GalleryCardsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
